export const REGENRATE_TOKEN_API = '/api/v1/user/token/reset';
